export const HEADER_CONTENT_HEIGHT = '4.5rem';
export const HEADER_PADDING = '4.5rem';
export const FOOTER_HEIGHT = '64px';
